import { RouteConfig } from 'vue-router'

const route: RouteConfig[] = [
  {
    path: '/lessons',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/Lesson/Index.vue'),
        children: [
          {
            path: ':lessonId',
            component: () => import('pages/Lesson/Detail.vue')
          },
          {
            path: 'new',
            component: () => import('pages/Lesson/Detail.vue')
          }
        ]
      }
    ],
    meta: { requiresAuth: true, requiresEditor: true }
  },
  {
    path: '/lessons',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: 'attend',
        component: () => import('pages/Dashboard/Index.vue')
      },
      {
        path: 'teach',
        component: () => import('pages/Dashboard/Index.vue')
      }
    ],
    meta: { requiresAuth: true }
  }
]

export default route
